import React from 'react';
import PropTypes from 'prop-types';
import CommonAppSetup from '../../../common/common-app-setup/CommonAppSetup';
import Components from '../../../common/Components';
import joinClassNames from "../../../common/JoinClassNames";

const propTypes = {
	// message to display, can be: numbers, strings, elements or an array (or fragment) containing these types.
	children: PropTypes.node.isRequired,

	// CSS class name to add to the wrapper
	className: PropTypes.string,

	// The name of the field the error message is for
	// This will create a label -> id relationship
	field: PropTypes.string,

	//possible future idea:
	// placement - how to orient the error (little arrow will changes sides)
	// dismissible - user can hide the message
	//    onDismiss / onClick callback
	//    visible state
};

const defaultProps = {
	className: undefined,
	field: undefined,
};

export default class FormError extends React.Component {
	render() {
		return (
			<label
				className={joinClassNames(
					'form-error',
					this.props.className,
					CommonAppSetup.getClassName(Components.FORM_ERROR, 'wrapper'),
				)}
				htmlFor={this.props.field}
			>
				{this.props.children}
			</label>
		);
	}
}

FormError.propTypes = propTypes;
FormError.defaultProps = defaultProps;